<template>
    <rubinred-form class="uk-form-stacked" ref="form">
        <div uk-grid class="uk-grid-small" slot="fields">
            <div class="uk-width-1-1">
                <form-advanced-select
                        name="store"
                        slug="store"
                        :validations="['required']"
                        :values="stores"
                        :value="initialValue ? initialValue.id : null"
                >
                    <div slot="placeholder" class="uk-padding-small uk-padding-remove-horizontal">
                        {{ $t('rubinred.ecommerce.orders.checkout.step-2.pick_store') }}
                    </div>
                    <div slot="item" slot-scope="{item, index}" class="uk-padding-small uk-padding-remove-horizontal uk-flex uk-flex-wrap uk-flex-between@s">
                        <div class="uk-width-1-2@s uk-text-bold">
                            {{ item.name }} - {{ item.city }}
                        </div>
                        <div class="uk-width-1-2@s uk-text-right@s">
                            {{ item.street }}, {{ (item.region ? item.region.name : '' ) + ' ' }}{{ item.postcode }}
                            {{ item.country ? '(' + item.country.code + ')' : '' }}
                        </div>
                    </div>
                </form-advanced-select>
            </div>
        </div>
    </rubinred-form>
</template>

<script>
  export default {
    inject: ['registerHandler'],
    props: {
      stores: {
        type: [Array, Object],
        required: true,
      },
      slug: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        initialValue: this.$store.state.checkout.shipping.store,
      };
    },
    created() {
      this.registerHandler(this);
    },
    methods: {
      validate() {
        return this.$refs.form.performValidation();
      },
      getData() {
        return this.$refs.form.getValues();
      }
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/shipping/PickupStoreHandler.vue